import creditTypes from "./credit.types";

export const setCreditTab = (n) => ({
  type: creditTypes.SET_CREDIT_TAB,
  payload: n,
});

export const fetchAccountDeatailStart = () => ({
  type: creditTypes.FETCH_ACCOUNTDEATAIL_START,
});

export const fetchAccountDeatailSuccess = (data) => ({
  type: creditTypes.FETCH_ACCOUNTDEATAIL_SUCCESS,
  payload: data,
});

// async
let detailsCounter = 0;
export const fetchAccountDeatailAsync = (socket) => (dispatch) => {
  dispatch(fetchAccountDeatailStart());

  socket.emit("get_account_detail", {});

  if (detailsCounter++ !== 0) return;
  socket.on("response_account_detail", (data) => {
    dispatch(fetchAccountDeatailSuccess(data));
  });
};
